// extracted by mini-css-extract-plugin
module.exports = {"ActiveQuiz":"ActiveQuiz_ActiveQuiz__18R75","Question":"ActiveQuiz_Question__12acG"};